export const RecommendationsTrackingTypes = {
    SHOW: 'show',
    CLICK: 'click',
    ORDER: 'order',
}

export type RecommendationsTrackingType =
    (typeof RecommendationsTrackingTypes)[keyof typeof RecommendationsTrackingTypes]
